import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {InsoleCadProcessRepository} from "./impl/service/ngrx/insoleCadProcess.repository";
import {InsoleCadProcessDataService} from "./impl/service/ngrx/insoleCadProcess.data.service";

@NgModule({
})
export class InsoleCadProcessModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsoleCadProcessRepository,
                 dataService: InsoleCadProcessDataService,
    ) {

        entityDataService.registerServices({
            InsoleCadProcess: dataService,
        });

        entityServices.registerEntityCollectionServices({
            InsoleCadProcess: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
